import React from 'react';
import { Pencil } from 'lucide-react';
import { ImagenOpcion } from './TarjetaOpcion';
import { bordadoElegido, contextoCamisa } from './tiendaUtils';

const bordadoDe = (g, valor, mangaCorta) => {
  if (!g.bordado || !valor?.texto) return {};
  const { ubicacion, color } = bordadoElegido(g, valor, mangaCorta);
  return { ubicacion, color_hilo: color };
};

export const armarResumen = (grupos, sel) => {
  const { mangaCorta } = contextoCamisa(grupos, sel);
  return grupos
    .map((g, i) => ({
      paso: i, grupo_nombre: g.nombre, tipo: g.tipo, texto: sel[g.id]?.texto || '',
      opciones: g.opciones.filter(o => (sel[g.id]?.opcion_ids || []).includes(o.id)),
      ...bordadoDe(g, sel[g.id], mangaCorta),
    }))
    .filter(s => s.texto || s.opciones.length);
};

const esClaro = (hex) => Boolean(hex) && (0.299 * parseInt(hex.slice(1, 3), 16) + 0.587 * parseInt(hex.slice(3, 5), 16) + 0.114 * parseInt(hex.slice(5, 7), 16)) > 190;

const Miniatura = ({ s }) => (s.tipo === 'texto'
  ? (
    <span className="flex h-full items-center justify-center rounded font-serif text-sm font-semibold"
      style={{ color: s.color_hilo?.hex || '#000', background: esClaro(s.color_hilo?.hex) ? '#4B5563' : 'transparent' }}>
      {s.texto}
    </span>
  )
  : <ImagenOpcion url={s.opciones[0]?.imagen_url} alt={s.opciones[0]?.titulo} />);

export default function ResumenSelecciones({ selecciones, onEditar, testId = 'resumen-selecciones' }) {
  return (
    <ul className="divide-y divide-zinc-800" data-testid={testId}>
      {selecciones.map((s, i) => (
        <li key={`${s.grupo_nombre}-${i}`} className="flex items-center gap-3 py-3">
          <div className="h-12 w-12 shrink-0 overflow-hidden rounded-lg bg-zinc-100 p-1"><Miniatura s={s} /></div>
          <div className="min-w-0 flex-1">
            <p className="text-[11px] uppercase tracking-wider text-zinc-500">{s.grupo_nombre}</p>
            <p className="truncate text-sm font-medium text-white">{s.texto || s.opciones.map(o => o.titulo).join(', ')}</p>
            {s.ubicacion && (
              <p className="truncate text-xs text-zinc-400" data-testid={`${testId}-bordado-${i}`}>
                {s.ubicacion.titulo} · hilo {s.color_hilo?.nombre}
              </p>
            )}
          </div>
          {onEditar && (
            <button type="button" onClick={() => onEditar(s.paso)} className="flex items-center gap-1 rounded-lg px-2 py-1.5 text-xs text-[#C9A962] hover:bg-[#C9A962]/10" data-testid={`resumen-editar-${i}`}>
              <Pencil className="h-3.5 w-3.5" />Cambiar
            </button>
          )}
        </li>
      ))}
    </ul>
  );
}
